export default {
  baseURL:
    process.env.NODE_ENV === 'production'
      ? 'https://api.connector.inobram.com.br/'
      : 'http://127.0.0.1:3333/api/v1',
  timeout: 30 * 1000 // 30 seconds
}



// WEBPACK FOOTER //
// ./src/config/axios.js